import React, { useLayoutEffect, useRef, useState } from "react";
import { get, map } from "lodash";
import "./readMore.scss";
import { Tooltip } from "antd";

export const ReadMore = (props: any) => {
  const ref = useRef(null);
  const [showLink, setShowLink] = useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useLayoutEffect(() => {
    if (get(ref, "current.clientHeight", 0) < get(ref, "current.scrollHeight", 0)) {
      setShowLink(true);
    }
  });

  return (
    <div style={{ width: "100%" }}>
      <span>
        <div ref={ref} className="ui_read-more">
          {map(props.text, (text: any, index: any) => {
            return <div key={index}>{`${index + 1} ${text}`} </div>;
          })}
        </div>
      </span>

      {showLink && (
        <Tooltip
          title={
            <div>
              {map(props.text, (text: any, index: any) => {
                return <div key={index}>{`${index + 1} ${text}`} </div>;
              })}
            </div>
          }
        >
          <span className="ui_read-more__link">{"Read More"}</span>
        </Tooltip>
      )}
    </div>
  );
};

export const ReadMoreForWidth = (props: any) => {
  const ref = useRef(null);
  const [showLink, setShowLink] = useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useLayoutEffect(() => {
    if (get(ref, "current.clientWidth", 0) < get(ref, "current.scrollWidth", 0)) {
      setShowLink(true);
    }
  });

  return (
    <div className="ui_read-more-width">
      <div ref={ref} className="ui_read-more-width__text">
        {props.text}
      </div>

      {showLink && (
        <Tooltip title={<div>{props.text}</div>}>
          <span className="ui_read-more-width__link">{"Read More"}</span>
        </Tooltip>
      )}
    </div>
  );
};
